import news from './news.js';

export default news;
